
import { eventClick } from "@/api/applicationTool";
import { getStore } from "@/utils/index.js";
import Vue from 'vue'
// 时间格式处理
export function transformTimestamp(timestamp, type) {
    console.log(timestamp, type)
    if (timestamp) {
        let a = new Date(timestamp).getTime();
        const date = new Date(a);
        const Y = date.getFullYear() + '-';
        const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
        // const s = date.getSeconds(); // 秒
        const dateString = type === 'd' ? Y + M + D : Y + M + D + h + m;
        return dateString
    }
}

// 操作埋点方法
export function buriedOperatingPoint(type, btnName, module, description) {
    let userInfo = JSON.parse(getStore("userInfo"));
    let userId = userInfo && userInfo.userId ? userInfo.userId : "";
    const params = {
        learningPathMetaId: '999', //工具固定传值： 999
        userId: userId, //用户ID
        type: type, //0-点击，1-进入某个表单，2-离开某个表单
        module: module, //传当前工具唯一id或key值
        btnName: btnName, //（自定义值）当前点击，保存，下载某表单,重命名
        courseUnit: description || "", //
        description: 'PC'
    };
    eventClick(params).then(
        (res) => {
            console.log(" ----- Buried operating point ----", res);
        },
        (err) => { }
    );
}

export function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(val) || regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}

// 判断是mac还是window
export function systemProperty() {
    var agent = navigator.userAgent.toLowerCase();
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        return 'win'
    }
    if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        return 'win'
    }
    if (isMac) {
        return 'mac'
    }
}


// WEBPACK FOOTER //
// ./src/utils/applicationTool.js